import { axiosInstance as request } from '@api/rest.service'

const api = subscriptionId => `/subscriptions/${subscriptionId}/subscription-periods`

/**
 * @description GET /subscriptions/${subscriptionId}/subscription-periods/orders-and-invoices
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_ORDERS_INVOICES = subscriptionId =>
  request.get(`${api(subscriptionId)}/orders-and-invoices`)

/**
 * @description GET /subscriptions/${subscriptionId}/subscription-periods/emails-and-history
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_EMAIL_HISTORY = subscriptionId => request.get(`${api(subscriptionId)}/emails-and-history`)
